/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    issueQuoteVariation,
    checkSoftReferral,
    postSoftReferral,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import IssueContainer from '../components/IssueContainer'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        step05: state.step05,
        softReferrals: state.step05.softReferrals,
        quoteId: props.quoteId,
        varId: props.varId,
        postSoftRef: state.step05.postSoftRef,
    }
}

export default connect(
    mapStateToProps,
    {
        issueQuoteVariation: issueQuoteVariation,
        checkSoftReferral: checkSoftReferral,
        postSoftReferral: postSoftReferral,
    }
)(IssueContainer)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/containers/IssueContainer.tsx